import React from 'react';

interface ArrowSlimRightIconProps extends React.SVGProps<SVGSVGElement> {
	width?: number;
	height?: number;
	fill?: string;
}

export function ArrowSlimRightIcon({
	width = 16,
	height = 16,
	fill = 'currentColor',
	...props
}: Readonly<ArrowSlimRightIconProps>): JSX.Element {
	return (
		<svg
			{...props}
			fill="none"
			width={width}
			height={height}
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#arrow_slim_right)">
				<path
					d="M11.9428 8.33383L11.94 8.34292C11.863 8.59694 11.7119 8.85963 11.4865 9.08942L6.53038 14.1437C6.23864 14.4413 5.89598 14.6092 5.59023 14.6537C5.28498 14.6982 5.03994 14.6196 4.88307 14.4596C4.72555 14.299 4.64736 14.0465 4.69142 13.7319C4.73545 13.4176 4.90113 13.0671 5.19283 12.7696L9.60861 8.2664C9.75015 8.12205 9.75015 7.88948 9.60861 7.74513L5.18025 3.22907C4.88855 2.93159 4.72287 2.58109 4.67884 2.26676C4.63478 1.95223 4.71297 1.69972 4.87049 1.53907C5.02736 1.37911 5.2724 1.30052 5.57765 1.34499C5.8834 1.38954 6.22606 1.55745 6.5178 1.85497L11.4739 6.90927C11.6385 7.07705 11.7638 7.26277 11.8494 7.45028C11.8572 7.46719 11.8661 7.48349 11.8763 7.49903C11.989 7.6717 12.0332 7.92009 11.9731 8.21238L11.9716 8.22052C11.9644 8.26017 11.9547 8.29798 11.9428 8.33383Z"
					fill={fill}
				/>
			</g>
			<defs>
				<clipPath id="arrow_slim_right">
					<rect width={16} height={16} fill="white" transform="matrix(-1 0 0 -1 16 16)" />
				</clipPath>
			</defs>
		</svg>
	);
}
